import { useCallback } from "react";
import { useLingui } from "@lingui/react";
import { useErrorToast } from "../showToast";
import AuthController from "../../controllers/AuthController";
import { Errors } from "../../errors";
import {
  AUTH_CHANGE_EMAIL_FAILED_TEXT,
  UNEXPECTED_ERROR_TEXT,
} from "../constants/i18n-strings";

export function useEmailChange(handleErrors: boolean) {
  const showErrorToast = useErrorToast();
  const { _: i18n } = useLingui();

  const displayChangeError = useCallback(
    (message: string) => {
      if (message.includes(Errors.ChangeEmailFailed)) {
        showErrorToast(i18n(AUTH_CHANGE_EMAIL_FAILED_TEXT));
      } else {
        showErrorToast(message);
      }
    },
    [showErrorToast, i18n]
  );

  const requestEmailChange = useCallback(
    async (password: string, oldEmail: string, newEmail: string) => {
      try {
        const changeEmailResult = await AuthController.requestEmailChange({
          password,
          oldEmail,
          newEmail,
        });
        return changeEmailResult;
      } catch (e) {
        if (!handleErrors) throw e;

        if (e instanceof Error) {
          displayChangeError(e.message);
        } else {
          showErrorToast(i18n(UNEXPECTED_ERROR_TEXT));
        }
        return false;
      }
    },
    [showErrorToast, displayChangeError, handleErrors, i18n]
  );

  return { requestEmailChange, displayChangeError };
}
